import PodcastComingUpNextComponent from "@routes/Article/components/PodcastArticle/PodcastComingUpNextComponent";
import PodcastHeroComponent from "@routes/Article/components/PodcastArticle/PodcastHeroComponent";
import {
  FeedArticleData,
  FeedArticleItems,
  PodcastDataType,
} from "@routes/Article/utils/types";

type ArticleTopFoldPodcastProps = {
  /** Podcast details to display podcast hero section */
  podcast: PodcastDataType | undefined;
  /** Article data for the podcast article */
  article: FeedArticleData;
  /** Podcast coming up next articles */
  podcastsComingUpNextData: FeedArticleItems[];
};

/**
 * Component to display top section of podcast article page
 */
const ArticleTopFoldPodcast = ({
  article: { title, blurb, publishTime, shortUrl },
  podcast,
  podcastsComingUpNextData,
}: ArticleTopFoldPodcastProps): React.ReactElement => {
  return (
    <>
      {podcast ? (
        <PodcastHeroComponent
          podcast={podcast}
          title={title || ""}
          blurb={blurb || ""}
          publishTime={publishTime}
          shortUrl={shortUrl || ""}
        />
      ) : null}

      {podcastsComingUpNextData ? (
        <PodcastComingUpNextComponent
          podcastsComingUpNextData={podcastsComingUpNextData}
          className="border-b border-gray-175 md:!mx-8 lg:!mx-auto"
          displayTitle
          title={title}
        />
      ) : null}
    </>
  );
};

export default ArticleTopFoldPodcast;
